import {
  AppUpdateAction,
  REFRESH_INTERVAL,
  SERVER_HEARTBEAT,
  SET_LAST_KNOWN_VERSION,
} from "constants/actionTypes";
import { AppUpdateStatus } from "constants/system";

const initialState = {
  refreshIntervalMs: NaN,
  serverTimeDriftMs: 0,
  appUpdateStatus: AppUpdateStatus.UP_TO_DATE,
  lastKnownVersion: null,
};

export default function systemReducer(state = initialState, action) {
  switch (action.type) {
    case REFRESH_INTERVAL.ACTION:
      return {
        ...state,
        refreshIntervalMs: action.refreshIntervalMs,
      };
    case SERVER_HEARTBEAT.FETCH_BULK.SUCCESS: {
      const {
        payload: {
          server_timestamp: timeOnServer,
          global_announcement: globalAnnouncement,
          bulk_email_limit: bulkEmailLimit,
          loads_refresh_minutes: loadsRefreshMinutes,
        },
      } = action;
      const drift = Date.now() - timeOnServer;
      return {
        ...state,
        serverTimeDriftMs: drift,
        globalAnnouncement,
        bulkEmailLimit,
        loadsRefreshMinutes,
      };
    }

    case AppUpdateAction.LOGOUT_REQUIRED:
      return {
        ...state,
        appUpdateStatus: AppUpdateStatus.LOGOUT_REQUIRED,
      };

    case AppUpdateAction.REFRESH_REQUIRED:
      return {
        ...state,
        appUpdateStatus: AppUpdateStatus.REFRESH_REQUIRED,
      };

    case AppUpdateAction.REFRESH_OPTIONAL:
      return {
        ...state,
        appUpdateStatus: AppUpdateStatus.REFRESH_OPTIONAL,
      };

    case AppUpdateAction.INVISIBLE:
      return {
        ...state,
        appUpdateStatus: AppUpdateStatus.INVISIBLE,
      };

    case AppUpdateAction.COMPLETE:
      return {
        ...state,
        appUpdateStatus: AppUpdateStatus.UP_TO_DATE,
      };

    case SET_LAST_KNOWN_VERSION:
      return {
        ...state,
        lastKnownVersion: action.version,
      };

    default:
      return state;
  }
}
